import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { FirestoreDB } from "utils/firebase";

// Live memory state for a user (users/{uid}/memoryState/current). Cards that
// may quote a memory compare their memoryRevision with this, the same check
// the Command Center uses (utils/memoryArtifacts).
const useMemoryState = (uid) => {
  const [memoryState, setMemoryState] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setMemoryState(null);
    if (!uid) return undefined;
    return onSnapshot(
      doc(FirestoreDB, `users/${uid}/memoryState/current`),
      (snapshot) => {
        setMemoryState(snapshot.exists() ? snapshot.data() : { revision: 0 });
        setLoaded(true);
      },
      () => {
        setMemoryState(null);
        setLoaded(true);
      },
    );
  }, [uid]);

  return { memoryState, loaded };
};

export default useMemoryState;
